import { Bell, BookOpen, Hash, Mail, MessageCircle, MessageSquare, MessagesSquare, Send, Smartphone, type LucideIcon } from 'lucide-react';
import type { DestinationTypeId } from '@/api/types';

export const DESTINATION_ICON: Record<DestinationTypeId, LucideIcon> = {
  email: Mail,
  sms: Smartphone,
  whatsapp: MessageCircle,
  telegram: Send,
  discord: MessagesSquare,
  teams: MessageSquare,
  slack: Hash,
  notion: BookOpen,
  push: Bell,
};
